import React from 'react';
import { Svg } from '../../../1_Atoms/Svg/Svg';

interface RangeSliderProps {
  startValue: number;
  endValue: number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  startValue,
  endValue,
  onChange
}) => {
  const RangeSliderThumbSize = 30;
  const RangeSliderTrackStepSize = 8;
  const circleThumbAdjustedPos = `((100% - ${RangeSliderThumbSize - RangeSliderTrackStepSize}px) - 8px)`;

  return (
    <div className="mz-range-slider">
      <div className="mz-range-slider__line">
        <div className="mz-range-slider__dots">
          {
            [...Array(11).keys()].map(i => {
              const isActive = (i > (startValue / 10) && i < (endValue / 10));
              return (
                <span
                  key={i}
                  className={`mz-range-slider__dot ${isActive ? 'active' : ''}`}
                ></span>
              );
            })
          }
          <div
            className="mz-range-slider__dots-filled-line"
            style={{
              width: `${endValue - startValue}%`,
              left: `${startValue}%`
            }}
          >
          </div>
        </div>
        <span className="mz-range-slider__line-start-label text--grey">0%</span>
        <span className="mz-range-slider__line-end-label text--grey">100%</span>
      </div>
      <input
        className="mz-range-slider__input"
        type="range"
        name="startValue"
        value={startValue}
        min="0"
        step="10"
        onChange={onChange}
      />
      <input
        className="mz-range-slider__input"
        type="range"
        name="endValue"
        value={endValue}
        max="100"
        step="10"
        onChange={onChange}
      />
      <div
        className="mz-range-slider__circle-thumb"
        style={{ left: `calc(${circleThumbAdjustedPos} * ${startValue / 100})` }}
      >
        <span className="strong">{startValue}%</span>
        <Svg type="slider_circle" />
      </div>
      <div
        className="mz-range-slider__circle-thumb"
        style={{ left: `calc(${circleThumbAdjustedPos} * ${endValue / 100})` }}
      >
        <span className="strong">{endValue}%</span>
        <Svg type="slider_circle" />
      </div>
    </div>
  );
}

export default RangeSlider;
